export function section05() {
    
    // Pillar 01
    gsap.timeline({
        scrollTrigger: {
            trigger: ".section.slice-5 .journey#journey-1",
            start: "top 85%",
            scrub: false,
        },
    })
    .from(".section.slice-5 .journey#journey-1 .pillar svg", {
        strokeDashoffset: 1500,
        duration: 1.5,
        ease: "expo.out"
    })
    .from(".section.slice-5 .journey#journey-1 .pillar .text", {
        opacity: 0,
        y: 25,
        duration: 0.35,
        ease: "expo.out"
    },"<+0.15")
    .from(".section.slice-5 .journey#journey-1 p", {
        opacity: 0,
        y: 25,
        duration: 0.35,
        ease: "expo.out"
    },"<+0.15")
    .from(".section.slice-5 .connector#connector-1 > div", {
        height: 0,
        duration: 0.5,
        ease: "expo.out"
    },"<+0.15")


    // Pillar 02
    gsap.timeline({
        scrollTrigger: {
            trigger: ".section.slice-5 .journey#journey-2",
            start: "top 85%",
            scrub: false,
        },
    })
    .from(".section.slice-5 .journey#journey-2 .pillar svg", {
        strokeDashoffset: 1500,
        duration: 1.5,
        ease: "expo.out"
    })
    .from(".section.slice-5 .journey#journey-2 .pillar .text", {
        opacity: 0,
        y: 25,
        duration: 0.35,
        ease: "expo.out"
    },"<+0.15")
    .from(".section.slice-5 .journey#journey-2 p", {
        opacity: 0,
        y: 25,
        duration: 0.35,
        ease: "expo.out"
    },"<+0.15")
    .from(".section.slice-5 .connector#connector-2 > div", {
        height: 0,
        duration: 0.5,
        ease: "expo.out"
    },"<+0.15")




    // Pillar 03
    gsap.timeline({
        scrollTrigger: {
            trigger: ".section.slice-5 .journey#journey-3",
            start: "top 85%",
            scrub: false,
        },
    })
    .from(".section.slice-5 .journey#journey-3 .pillar svg", {
        strokeDashoffset: 1500,
        duration: 1.5,
        ease: "expo.out"
    })
    .from(".section.slice-5 .journey#journey-3 .pillar .text", {
        opacity: 0,
        y: 25,
        duration: 0.35,
        ease: "expo.out"
    },"<+0.15")
    .from(".section.slice-5 .journey#journey-3 p", {
        opacity: 0,
        y: 25,
        duration: 0.35,
        ease: "expo.out"
    },"<+0.15")




    // Background Colour Change
    gsap.timeline({
        scrollTrigger: {
            trigger: ".section.slice-5 .journey#journey-1",
            start: "top 85%",
            end: "top top",
            scrub: true,
        },
    })
    .to(".section.slice-5", {
        background: "#D02127",
        duration: 0.5,
        ease: "expo.out"
    })
    gsap.timeline({
        scrollTrigger: {
            trigger: ".section.slice-5 .journey#journey-2",
            start: "top 85%",
            end: "top top",
            scrub: true,
        },
    })
    .to(".section.slice-5", {
        background: "#40B1B7",
        duration: 0.5,
        ease: "expo.out"
    })
    gsap.timeline({
        scrollTrigger: {
            trigger: ".section.slice-5 .journey#journey-3",
            start: "top 85%",
            end: "top top",
            scrub: true,
        },
    })
    .to(".section.slice-5", {
        background: "#3560A8",
        duration: 0.5,
        ease: "expo.out"
    })
}